import React, { useState } from 'react'
import styled from 'styled-components'
import { Flex, Caption1, Caption2, Image } from '@components/atoms'
import { iconQeustionMark } from '@images'

export const YoutubeListenTooltip = ({ }) => {
  const [isHoverQuestionMark, setIsHoverQuestionMark] = useState(false)
  return (
    <Flex>
      <Image
        src={iconQeustionMark}
        width="14px"
        height="14px"
        style={{ cursor: 'pointer' }}
        onMouseEnter={() => setIsHoverQuestionMark(true)}
        onMouseLeave={() => setIsHoverQuestionMark(false)}
      />
      <div style={{ position: 'relative' }}>
        {isHoverQuestionMark && (
          <QuestionTooltip>
            <Caption1 type="Bold">Daily Listen</Caption1>
            <Flex gap="2px">
              <Caption2 color="#949494" style={{ fontSize: 10 }}>
                Listen
              </Caption2>
              <Caption2 color="#646464" style={{ fontSize: 10 }}>
                *View
              </Caption2>
              <Caption2 color="#949494" style={{ fontSize: 10 }}>
                +Listen
              </Caption2>
              <Caption2 color="#646464" style={{ fontSize: 10 }}>
                *Y.T Music
              </Caption2>
            </Flex>
          </QuestionTooltip>
        )}
      </div>
    </Flex>
  )
}

const QuestionTooltip = styled(Flex)`
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  gap: 6px;
  position: absolute;

  top: 32px;
  right: -140px;

  width: 171px;
  height: 55px;
  padding: 8px 12px;
  border-radius: 6px;
  box-shadow: 0 4px 10px 0 rgba(36, 36, 36, 0.16);
  background-color: #fff;
  z-index: 1;
`
